import { render, staticRenderFns } from "./ContratacaoDetalhesTabs.vue?vue&type=template&id=38072ebb"
import script from "./ContratacaoDetalhesTabs.vue?vue&type=script&lang=js"
export * from "./ContratacaoDetalhesTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports